import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 200)
  }

  //Recarga la pagina completa (no solo el frame de resultados), para que los
  //demas selectores (para quien, que buscas) se recalculen segun el plan elegido
  searchFullPage() {
    clearTimeout(this.timeout)
    const url = new URL(this.element.action)
    url.search = new URLSearchParams(new FormData(this.element)).toString()
    Turbo.visit(url.toString(), { action: "advance" })
  }
}
